module.exports = __webpack_public_path__ + "static/media/eye-close.38e9796c.svg";